export default {
  BUCashWithDrawList: {
    Title: 'Nhập quỹ tiền mặt',
    Filter: {
      RefDate: 'Ngày điều chỉnh',
    },
  },
  BUCashWithDrawDetail: {
    Title: 'Phiếu rút tiền kho bạc',
    AccountObjectID: 'Người nhận',
    AccountObjectName: 'Họ tên',
    AccountObjectAddress: 'Địa chỉ',
    TKKB: 'TKKB',
    TKKBTooltip: 'Tài khoản kho bạc',
    Description: 'Diễn giải',
    CTReference: 'CT tham chiếu',
    CTReferenceTooltip: 'Chứng từ tham chiếu',
    GRDate: 'Ngày GR',
    GRDateTooltip: 'Ngày giấy rút',
    PostedDate: 'Ngày HT',
    PostedDateTooltip: 'Ngày hạch toán',
    GRNo: 'Số GR',
    GRNoTooltip: 'Số giấy rút',
    PTNo: 'Số PT',
    PTNoTooltip: 'Số phiếu thu',
    BuPlanTitle: 'Thuộc dự toán',
  },
};
